import React from 'react';
import { MultiSelect } from '../../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from '../materials/tabs/Filters/CollapsibleFilterBar';

export interface TeamMemberFilters {
  search: string;
  role: string[];
  status: string[];
}

interface TeamMemberFiltersProps {
  filters: TeamMemberFilters;
  onFiltersChange: (filters: TeamMemberFilters) => void;
  roles: string[];
  filteredCount?: number;
}

export const TeamMemberFilters: React.FC<TeamMemberFiltersProps> = ({
  filters,
  onFiltersChange,
  roles,
  filteredCount,
}) => {
  const handleFilterChange = (key: keyof TeamMemberFilters, value: string | string[]) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const handleClearFilters = () => {
    onFiltersChange({ search: '', role: [], status: [] });
  };

  const activeFilterCount = filters.role.length + filters.status.length;

  return (
    <CollapsibleFilterBar
      searchQuery={filters.search}
      onSearchChange={(v) => handleFilterChange('search', v)}
      searchPlaceholder="Search by name or email..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel="members"
      onResetFilters={handleClearFilters}
    >
      <MultiSelect
        options={roles.map((role) => ({ value: role, label: role }))}
        selected={filters.role}
        onChange={(value) => handleFilterChange('role', value)}
        placeholder="Role"
      />
      <MultiSelect
        options={[
          { value: 'active', label: 'Active' },
          { value: 'inactive', label: 'Inactive' },
        ]}
        selected={filters.status}
        onChange={(value) => handleFilterChange('status', value)}
        placeholder="Status"
        isSearchable={false}
      />
    </CollapsibleFilterBar>
  );
};
